'use client';

import DesktopTopNav from '@/components/common/DesktopTopNav';
import MobileBottomNav from '@/components/common/MobileBottomNav';

/**
 * Dual navigation: Desktop top nav (lg+) + Mobile bottom nav (below lg).
 * Replaces the previous sidebar. No sidebar margin; use AppContent for main area.
 */
export default function Sidebar() {
  return (
    <>
      <DesktopTopNav />
      <MobileBottomNav />
    </>
  );
}
